import React from "react";
import { Grid, Row, Col, Panel } from "react-bootstrap";
import { Field, reduxForm } from "redux-form";
import { SimpleField } from "../common/Inputs";
import { PhoneInput } from "../common/PhoneInput";

let Filter = class extends React.Component {
    render() {
        const { error, anyTouched, showError } = this.props;
        return (
            <Grid fluid={true} >
                <Row>
                    <Col lg={12}>
                        <Panel>
                            <Panel.Heading>Фильтр</Panel.Heading>
                            <Panel.Body>
                                <Col lg={4} xs={12} sm={8} md={6}>
                                    <Row>
                                        <Col>
                                            <form className='form-horizontal'>
                                                <Field
                                                    name='name'
                                                    component={SimpleField}
                                                    label='Имя' />
                                                <Field
                                                    name='phone'
                                                    component={PhoneInput}
                                                    label='Телефон' />
                                            </form>
                                        </Col>
                                        <Col style={{ textAlign: 'center' }}>
                                            {(anyTouched || showError) && error && <strong style={{ color: 'red', marginLeft: '5px' }}>{error}</strong>}
                                        </Col>
                                    </Row>
                                </Col>
                            </Panel.Body>
                        </Panel>
                    </Col>
                </Row>
            </Grid>
        )
    }
}

Filter = reduxForm({
    form: 'customerFilter',
})(Filter);

export default Filter;


// WEBPACK FOOTER //
// ./src/components/customers/Filter.jsx